export default __webpack_public_path__ + "media/images/dog-decor-1-bc3b7001194f80cd59bda299de084a2e.png";